module.exports = __webpack_public_path__ + "img/paymentDummy2.b30209d.png";